import PropTypes from 'prop-types';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
class MeasureOnceOffscreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      measurements: null
    };
    this.setAndUseWrapperRef = this.setAndUseWrapperRef.bind(this);
  }
  measureChildElementDimensions(element) {
    // Use getBoundingClientRect instead of offsetWidth/Height so that we get the width/height _after_
    // transforms like rotation and scale are applied
    const {
      width,
      height
    } = element.getBoundingClientRect();

    // Only pass along the width and height because the X/Y values are thrown off by positioning the
    // the wrapper offscreen (and this component is only designed to give dimensions not all the bounds info)
    return {
      width,
      height
    };
  }
  setAndUseWrapperRef(element) {
    const {
      onMeasure
    } = this.props;
    const {
      measurements
    } = this.state;
    if (!measurements && element) {
      const child = element.firstElementChild;
      if (!child) {
        throw new Error('Element to measure in MeasureOnceOffscreen had no child');
      }
      const dimensions = this.measureChildElementDimensions(child);
      onMeasure(dimensions, child);
      this.setState({
        measurements: dimensions
      });
    }
  }
  render() {
    const {
      children,
      readyToMeasure
    } = this.props;
    const {
      measurements
    } = this.state;

    // After we've got measurements, unmount this (also wait readyToMeasure is true if passed)
    if (measurements || !readyToMeasure) {
      return null;
    }
    return /*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        top: -10000,
        left: -10000
      },
      ref: this.setAndUseWrapperRef,
      children: children
    });
  }
}
MeasureOnceOffscreen.propTypes = {
  children: PropTypes.node.isRequired,
  onMeasure: PropTypes.func.isRequired,
  readyToMeasure: PropTypes.bool
};
MeasureOnceOffscreen.defaultProps = {
  readyToMeasure: true
};
export default MeasureOnceOffscreen;